import { render } from "./diamondRegionList.vue?vue&type=template&id=7085ee55&scoped=true"
import script from "./diamondRegionList.vue?vue&type=script&lang=js"
export * from "./diamondRegionList.vue?vue&type=script&lang=js"

import "./diamondRegionList.vue?vue&type=style&index=0&id=7085ee55&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7085ee55"]])

export default __exports__